

export default {
    planlistdata :[
        {
          "id": "1",
          "PlanName": "Free",
          "PlanType": "Monthly",
          "Price": "$00.00",
          "Users": "2",
          "Suppliers": "1",
          "Products": "10",
          "Invoice": "1",
          "CreatedDate": "19 Jan 2024",
          "Status": "Active",
          "Action": "Edit\n                            \n                          \n                          \n                            \n                              \n                              Delete"
        },
        {
          "id": "2",
          "PlanName": "Basic",
          "PlanType": "Yearly",
          "Price": "$19.99",
          "Users": "5",
          "Suppliers": "5",
          "Products": "100",
          "Invoice": "10",
          "CreatedDate": "16 Jan 2024",
          "Status": "Active",
          "Action": "Edit\n                            \n                          \n                          \n                            \n                              \n                              Delete"
        },
        {
          "id": "3",
          "PlanName": "Premium",
          "PlanType": "Lifetime",
          "Price": "$6549.99",
          "Users": "50",
          "Suppliers": "10",
          "Products": "1000",
          "Invoice": "1000",
          "CreatedDate": "12 Jan 2024",
          "Status": "Active",
          "Action": "Edit\n                            \n                          \n                          \n                            \n                              \n                              Delete"
        },
        {
          "id": "4",
          "PlanName": "Enterprise",
          "PlanType": "Yearly",
          "Price": "$99.99",
          "Users": "1000",
          "Suppliers": "Unlimited",
          "Products": "Unlimited",
          "Invoice": "Unlimited",
          "CreatedDate": "9 Jan 2024",
          "Status": "Active",
          "Action": "Edit\n                            \n                          \n                          \n                            \n                              \n                              Delete"
        },
        {
          "id": "5",
          "PlanName": "Advanced",
          "PlanType": "Monthly",
          "Price": "$499.99",
          "Users": "Unlimited",
          "Suppliers": "Unlimited",
          "Products": "Unlimited",
          "Invoice": "Unlimited",
          "CreatedDate": "5 Jan 2024",
          "Status": "Active",
          "Action": "Edit\n                            \n                          \n                          \n                            \n                              \n                              Delete"
        }
      ]
}
